/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import * as PropTypes from "prop-types";
import PaymentSummary from "./PaymentSummary";
import CountrySelect from "./CountrySelect";
import { useSelector } from "react-redux";
import { USD } from "../../../../../utils/constants";
import AppBankList from "../../../../../components/AppBankList";
import PaymentForm from "../../../../../components/PaymentForm";

export default function Pockyt(props) {
  const { amount, setActive, active, mode } = props;
  const [country, setCountry] = useState(null);
  const [currency, setCurrency] = useState(null);
  const bankList = useSelector(({ transfer }) => transfer.connectedBanks);
  const [bank, setBank] = useState(null);
  const bankFlag = useSelector(({ transfer }) => transfer.connectBank);
  if (bankList?.length === 0 || bankFlag) {
    if (active === 2) {
      return (
        <CountrySelect
          active={active}
          setActive={setActive}
          country={country}
          setCountry={setCountry}
          currency={currency}
          setCurrency={setCurrency}
        />
      );
    }
    if (active === 3) {
      return (
        <PaymentForm
          active={active}
          setActive={setActive}
          country={country}
          currency={currency}
          mode={mode}
        />
      );
    }
  } else {
    if (active === 2) {
      return (
        <AppBankList
          active={active}
          setActive={setActive}
          bankList={bankList}
          bank={bank}
          mode={mode}
          setBank={setBank}
        />
      );
    }

  }
  if (active === 4) {
    return (
      <PaymentSummary active={active} amount={amount} setActive={setActive} bank={bank} paymentCurrency={(bank?.currency || USD).toUpperCase()}/>
    );
  }
}

Pockyt.propTypes = {
  amount: PropTypes.any,
  setActive: PropTypes.func,
  active: PropTypes.number,
};
